import axios from "axios";
import { Subject } from "rxjs";
import { apiUrls, urlQuery } from "../Common";
import API from "../Common/AxiosConfiguration";

const subject = new Subject();

export const TokenHolderService = {
  getObserved: () => subject.asObservable(),
  getTwentyFourHoursTraining: async (currentPage, form) => {
    const response = await API.post(
      `${apiUrls.twentyFourHoursTraining}${urlQuery.symbol}${urlQuery.page}${currentPage}`,
      form
    );
    return response;
  },
  getIacProgramme: async (currentPage, form) => {
    const response = await API.post(
      `${apiUrls.iacProgramme}${urlQuery.symbol}${urlQuery.page}${currentPage}`,
      form
    );
    return response;
  },
  getSubjectList: async () => {
    const response = await API.post(`${apiUrls.getSubjectList}`);
    return response;
  },
  getCategoryList: async () => {
    const response = await API.post(`${apiUrls.getCategoryList}`);
    return response;
  },
  getSummaryBenefit: async (currentPage) => {
    const response = await API.post(
      `${apiUrls.getSummaryBenefit}${urlQuery.symbol}${urlQuery.page}${currentPage}`
    );
    return response;
  },
  getSetting: async () => {
    const response = await API.post(`${apiUrls.settings}`);
    return response;
  },
  getTrainer: async () => {
    const response = await API.post(`${apiUrls.getTrainer}`);
    return response;
  },
  addLightWorker: async (form) => {
    const response = await API.post(`${apiUrls.addLightWorker}`, form);
    return response;
  },
  getIPFSData: async (url) => {
    const response = await axios.get(url);
    return response;
  },
  getEmailInfo: async (form) => {
    const response = await API.post(`${apiUrls.getEmail}`, form);
    return response;
  },
  addEmailInfo: async (form) => {
    const response = await API.post(`${apiUrls.addEmail}`, form);
    return response;
  },
  getTimezone: async () => {
    const response = await axios.get(`${apiUrls.getTimezone}`);
    return response;
  },
};
